import { render, staticRenderFns } from "./AppCollapseItemCheckbox.vue?vue&type=template&id=9778c134&"
import script from "./AppCollapseItemCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItemCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports